import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ChatLayout from "./components/ChatLayout";
import { useChatStore } from "./lib/useChatStore";
import { listConversations, loadMessages } from "./lib/api";
import { LegalStyleIndicator } from "./components/LegalStyleIndicator";

const LegalChat = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { conversationId } = useParams();
  const { 
    setActiveConversation, 
    setMessages, 
    clearMessages, 
    setConversations,
    conversations,
    activeConversationId,
    setPendingInitialMessage
  } = useChatStore();

  // Handle initialMessage from navigation state (e.g. from Jurisprudências)
  useEffect(() => {
    const state = location.state as { initialMessage?: string } | null;
    if (state?.initialMessage) {
      setPendingInitialMessage(state.initialMessage);
      // Clear state to prevent re-triggering
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, setPendingInitialMessage, navigate, location.pathname]);

  useEffect(() => {
    if (!user) {
      navigate("/");
      return;
    }

    const loadData = async () => {
      const convs = await listConversations();
      
      // ✅ CORREÇÃO: Só sincronizar store se não houver conversas no store
      // Isso evita sobrescrever criações otimísticas do ChatInput
      setConversations(prev => prev.length === 0 ? convs : prev);
      
      if (conversationId) {
        // Carregar conversa específica
        setActiveConversation(conversationId);
        const msgs = await loadMessages(conversationId);
        setMessages(msgs);
      } else if (convs.length > 0) {
        // Redirecionar para primeira conversa
        navigate(`/chat-juridico/${convs[0].id}`, { replace: true });
      } else {
        // Sem conversas = estado vazio
        clearMessages();
      }
    };

    loadData();
  }, [conversationId, user, navigate, setActiveConversation, setMessages, clearMessages, setConversations]);

  if (!user) return null;

  // Buscar template da conversa ativa
  const activeConv = conversations.find(c => c.id === activeConversationId);
  const currentTemplate = activeConv?.template;

  return (
    <div className="flex h-full min-h-0 w-full bg-background overflow-hidden flex-1">
      <ChatLayout 
        activeConversationId={activeConversationId}
        currentTemplate={currentTemplate}
        conversationTitle={activeConv?.title}
        conversationOwnerId={activeConv?.user_id}
      />
    </div>
  );
};

export default LegalChat;
